import { Path,SVG } from '@wordpress/primitives';

export const Icon = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path
			d="M20 18.75C20.4142 18.75 20.75 19.0858 20.75 19.5V20C20.75 21.5188 19.5188 22.75 18 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V19.5C3.25 19.0858 3.58579 18.75 4 18.75C4.41421 18.75 4.75 19.0858 4.75 19.5V20C4.75 20.6904 5.30964 21.25 6 21.25H18C18.6904 21.25 19.25 20.6904 19.25 20V19.5C19.25 19.0858 19.5858 18.75 20 18.75ZM12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V15.3604L17.0098 11.6797C17.3232 11.409 17.7966 11.4435 18.0674 11.7568C18.3382 12.0702 18.3036 12.5436 17.9902 12.8145L12.4902 17.5674L12 17.9912L11.5098 17.5674L6.00977 12.8145C5.69639 12.5436 5.6618 12.0702 5.93262 11.7568C6.20342 11.4435 6.67684 11.409 6.99023 11.6797L11.25 15.3604V2C11.25 1.58579 11.5858 1.25 12 1.25Z"
		/>
	</SVG>
);
